import { IConfigurationRegistry } from "../../../../base/domain/configuration";
import { Directory } from "../../../../base/domain/drawing";
import { AuthenticatedService } from "../../../../base/infrastructure";
import { IConfiguration } from "../../../domain/configuration";
import { EditableFormatSummary, IEditableFormatTreeRepository } from "../../../domain/editableFormat";
import { IEditableFormatFolderRootBean } from "./beans";
import { TranslatorFactory } from "./translators";

export class EditableFormatTreeRepository extends AuthenticatedService implements IEditableFormatTreeRepository {
  protected readonly _treePath: string;

  constructor(getToken: () => string, protected readonly _configurationRegistry: IConfigurationRegistry<IConfiguration>, _treePath?: string) {
    super(getToken);
    this._treePath = _treePath ? _treePath : "tree";
    this._translatorFactory = new TranslatorFactory(_configurationRegistry);
  }

  protected readonly _translatorFactory: TranslatorFactory;

  async getFormatTree(): Promise<Directory<number, EditableFormatSummary>[]> {
    const url = "api/format-editor/" + this._treePath + "/hierarchy";
    const result = await this.get<IEditableFormatFolderRootBean>(url);
    return this._translatorFactory.create().toFormatsTree(() => this.token, result.data);
  }

  async addDirectory(name: string, parent: number, index: number): Promise<number> {
    const url = "api/format-editor/" + this._treePath + "/new-folder";
    const query = {
      parentId: parent,
      name: name,
      index: index,
    };
    const result = await this.post<number>(url, query);
    return result.data;
  }

  async moveDirectory(id: number, parent: number, index: number): Promise<void> {
    const url = "api/format-editor/" + this._treePath + "/move-folder";
    const query = {
      parentId: parent,
      folderId: id,
      index: index,
    };
    await this.post<void>(url, query);
  }

  async deleteDirectory(id: number): Promise<void> {
    const url = "api/format-editor/" + this._treePath + "/delete-folder";
    const query = {
      folderId: id,
    };
    await this.post<void>(url, query);
  }

  async renameDirectory(id: number, name: string): Promise<void> {
    const url = "api/format-editor/" + this._treePath + "/rename-folder";
    const query = {
      folderId: id,
      name: name,
    };
    await this.post<void>(url, query);
  }

  async addFormat(id: number, name: string, parent: number, index: number): Promise<void> {
    const url = "api/format-editor/" + this._treePath + "/new-format";
    const query = {
      parentId: parent,
      formatId: id,
      name: !name ? "" : name,
      index: index,
    };
    await this.post<void>(url, query);
  }

  async moveFormat(id: number, parent: number, index: number): Promise<void> {
    const url = "api/format-editor/" + this._treePath + "/move-format";
    const query = {
      parentId: parent,
      formatId: id,
      index: index,
    };
    await this.post<void>(url, query);
  }

  async deleteFormat(id: number): Promise<void> {
    const url = "api/format-editor/" + this._treePath + "/delete-format";
    const query = {
      formatId: id,
    };
    await this.post<void>(url, query);
  }

  async renameFormat(id: number, name: string): Promise<void> {
    const url = "api/format-editor/" + this._treePath + "/rename-format";
    const query = {
      formatId: id,
      name: name,
    };
    await this.post<void>(url, query);
  }
}
